function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

// Share functionality
function initShareButton() {
  const shareButton = document.getElementById('shareButton');
  if (!shareButton) return;

  shareButton.addEventListener('click', async function() {
    const url = this.dataset.url;
    const title = this.dataset.title;
    const shareText = document.getElementById('shareText');

    // Check if device is mobile and Web Share API is supported
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    if (isMobile && navigator.share) {
      try {
        await navigator.share({
          title: title,
          url: url
        });
      } catch (err) {
        // User cancelled or error occurred, fallback to clipboard
        copyToClipboard(url);
        updateShareText(shareText);
      }
    } else {
      // Desktop: always copy to clipboard
      copyToClipboard(url);
      updateShareText(shareText);
    }
  });
}

function copyToClipboard(text) {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text).then(() => {
      // Copy successful
    }).catch(() => {
      // Fallback for older browsers
      fallbackCopyToClipboard(text);
    });
  } else {
    fallbackCopyToClipboard(text);
  }
}

function fallbackCopyToClipboard(text) {
  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.position = 'fixed';
  textArea.style.left = '-999999px';
  textArea.style.top = '-999999px';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  
  try {
    document.execCommand('copy');
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err);
  }
  
  document.body.removeChild(textArea);
}

function updateShareText(shareTextElement) {
  if (!shareTextElement) return;
  
  shareTextElement.textContent = 'link copied!';
  
  // Reset text back to "Share" after 3 seconds
  setTimeout(() => {
    shareTextElement.textContent = 'share';
  }, 3000);
}


// Initialize share functionality when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  initShareButton();
}); 